import styled from 'styled-components';
import { Form, Icon, Dropdown } from 'semantic-ui-react';

export const LpnRnVerificationContainer = styled.div`
  border-radius: 10px;
  box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.25);
  margin: 72px 15px 15px;
  max-width: 620px;
  padding: 35px 50px;
  text-align: center;

  @media only screen and (max-width: 767px) {
    margin: 30px 15px 15px;
  }
`;

export const TitleText = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  margin: 15px 0;
`;

export const SubTitleText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 23px;
  margin: 15px 0px 25px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 35px 0px 10px;
  /* flex-direction: column !important; */

  @media only screen and (max-width: 590px) {
    justify-content: center;
  }
`;

export const InputColumnWrapper = styled.div`
  width: 215px;

  @media only screen and (max-width: 590px) {
    width: 100%;
  }
`;

export const InputLabel = styled.label`
  font-size: 14px;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 14px;
  margin-bottom: 10px !important;
  text-align: left;

  i {
    margin-left: 5px !important;
  }
`;

export const InputField = styled.input`
  border: 1px solid #7c2e97 !important;
  border-radius: 3px !important;
  height: 30px;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const DropdownField = styled(Dropdown)`
  align-items: center !important;
  border: 1px solid #7c2e97 !important;
  border-radius: 3px !important;
  display: flex !important;
  height: 30px;
  min-height: 30px !important;
  padding-bottom: 9.5px !important;
  padding-top: 9.5px !important;
  i {
    align-items: center !important;
    display: flex !important;
    height: 30px !important;
    padding-bottom: 9.5px !important;
    padding-top: 9.5px !important;
  }
`;

export const FormField = styled(Form.Field)`
  margin-bottom: 30px !important;

  .warning-message-mount-exit {
    opacity: 1;
  }
  .warning-message-mount-exit-active {
    opacity: 0;
    transition: opacity 500ms;
  }
  .warning-message-mount-enter {
    opacity: 0;
  }
  .warning-message-mount-enter-active {
    opacity: 1;
    transition: opacity 500ms;
  }
`;

export const WarningMessage = styled.div`
  color: #d62626;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  margin-top: 5px;
  text-align: left;
`;

export const FileColumnWrapper = styled.div`
  .file-name-mount-exit {
    opacity: 1;
  }
  .file-name-mount-exit-active {
    opacity: 1;
    transition: opacity 1ms;
  }
  .file-name-mount-enter {
    opacity: 0;
  }
  .file-name-mount-enter-active {
    opacity: 1;
    transition: opacity 500ms;
  }
`;

export const FileNameContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const CheckIconContainer = styled.div`
  i {
    color: #74b566;
    margin: 0px !important;
  }
`;

export const ClearIconContainer = styled.div`
  i {
    color: #000;
    margin: 0px !important;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const FileName = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  line-height: 14px;
  margin: 0 10px;
  max-width: 120px;
  word-break: break-all;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;

  @media only screen and (max-width: 590px) {
    margin-top: 40px;
    justify-content: center;
  }
`;

export const SubmitButton = styled.input`
  align-items: center;
  background-color: #a761a9;

  border: 2px solid #a761a9;
  border-radius: 8px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  font-size: 16px;
  font-weight: 500;
  height: 35px;
  justify-content: center;
  min-width: 105px;
  position: relative;
  transition: all 0.3s;

  &:hover {
    background-color: #fff;
    color: #a761a9;
    cursor: pointer;
    transition: all 0.3s;
  }
  &:focus {
    outline: none !important;
  }
`;

export const FooterText = styled.div`
  font-size: 13px;
  font-weight: 400;
  margin: 25px 0px 15px;
  text-align: left;
  @media only screen and (max-width: 590px) {
    text-align: center;
  }
`;

export const DropzoneField = styled.div`
  align-items: center;
  border-radius: 10px;
  border-style: dashed;
  border-width: 2px;
  color: #bdbdbd;
  display: flex;
  flex-direction: column;
  height: 180px;
  justify-content: center;
  margin: 25px 0px 15px;
  outline: none;
  padding: 20px;
  transition: border 0.24s ease-in-out;
  width: 185px;

  &:hover {
    cursor: pointer;
  }
`;

export const FolderIcon = styled(Icon)`
  box-sizing: border-box;
  color: #e38e66;
  font-size: 28px !important;
`;

export const DragTitle = styled.div`
  color: #000;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  margin-top: 10px;
`;
export const DragTitleOptional = styled.div`
  color: #000;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
`;

export const DragSubTitle = styled.div`
  color: #939597;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  margin-top: 10px;
  width: 170px;
`;

export const DragFileType = styled.div`
  color: #939597;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
  margin-top: 10px;
  width: 170px;
`;
